import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';
import Dropdown from 'antd/es/dropdown/dropdown';
import { IconButton } from '../controls/Controls';
import { useTranslation } from 'react-i18next';

const DataGridOverviewRowButton = ({ row, onPreviewClick, previewTooltip }) => {
  const { t } = useTranslation();

  const constructMenu = () => {
    if (!row.title_sk || !row.title_en) {
      return null;
    }

    const items = [
      {
        label: t('Zobraziť náhľad v slovenskej verzii'),
        key: 'sk',
      },
      {
        label: t('Zobraziť náhľad v anglickej verzii'),
        key: 'en',
      },
    ];

    return {
      items,
      onClick: (e) => {
        e.domEvent.stopPropagation();
        onPreviewClick(row, e.key);
      },
    };
  };

  const menu = useRef(constructMenu());
  return (
    <>
      {menu.current?.items.length > 1 ? (
        <Dropdown menu={menu.current} onClick={(e) => e.stopPropagation()}>
          <IconButton
            icon={<EyeOutlined />}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </Dropdown>
      ) : onPreviewClick ? (
        <IconButton
          icon={<EyeOutlined />}
          tooltip={previewTooltip || t('Zobraziť náhľad')}
          onClick={(e) => {
            e.stopPropagation();
            onPreviewClick(row);
          }}
        />
      ) : null}
    </>
  );
};
DataGridOverviewRowButton.propTypes = {
  row: PropTypes.object,
  onPreviewClick: PropTypes.func,
  previewTooltip: PropTypes.string,
};

export default DataGridOverviewRowButton;
